import { cn } from "@/lib/utils";

export const BRAND_LOGOS = [["ACK", "/brands/ack.png"], ["CATA", "/brands/cata.png"], ["VİKO", "/brands/viko.png"], ["MUTLUSAN", "/brands/mutlusan.png"], ["SIEMENS", "/brands/siemens.svg"]];

const Logo = ({ src, name, className }) => (
  <img src={src} alt={name} draggable={false} loading="eager" className={cn("w-auto object-contain select-none [filter:brightness(0)_invert(1)]", className)} />
);

// Giriş ekranı arka planı: koyu lacivert zemin, turuncu/mavi ışık, ızgara ve eğik kayan marka logoları
export function BrandBackdrop() {
  const row = [...BRAND_LOGOS, ...BRAND_LOGOS, ...BRAND_LOGOS];
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true" data-testid="login-brand-backdrop">
      <div className="absolute inset-0 bg-[#060A13]" />
      <div className="absolute -top-56 left-1/2 -translate-x-1/2 h-[640px] w-[960px] rounded-full bg-[#F55913]/20 blur-[150px]" />
      <div className="absolute -bottom-56 -left-40 h-[520px] w-[640px] rounded-full bg-[#1E5BFF]/15 blur-[140px]" />
      <div className="absolute inset-0 opacity-[0.06]" style={{ backgroundImage: "linear-gradient(rgba(255,255,255,.7) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,.7) 1px, transparent 1px)", backgroundSize: "56px 56px", WebkitMaskImage: "radial-gradient(circle at 50% 40%, black, transparent 75%)", maskImage: "radial-gradient(circle at 50% 40%, black, transparent 75%)" }} />
      <div className="absolute -inset-[30%] -rotate-[14deg] flex flex-col justify-center gap-20 opacity-[0.08]">
        {[0, 1, 2, 3, 4, 5, 6].map((r) => (
          <div key={r} className={cn("flex w-max items-center gap-28 ge-marquee", r % 2 === 1 && "ge-marquee-rev")} style={{ animationDuration: `${80 + r * 14}s` }}>
            {[...row, ...row].map(([n, src], i) => <Logo key={i} src={src} name={n} className="h-10 sm:h-12" />)}
          </div>
        ))}
      </div>
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_42%,transparent_0%,rgba(6,10,19,.6)_55%,#060A13_100%)]" />
    </div>
  );
}

// Alt şerit: markalar net görünür
export function BrandStrip() {
  return (
    <div className="relative mt-10 w-full max-w-3xl" data-testid="login-brand-strip">
      <div className="mx-auto flex flex-wrap sm:flex-nowrap items-center justify-center gap-x-7 gap-y-4 sm:gap-x-10 px-4">
        {BRAND_LOGOS.map(([n, src]) => (
          <Logo key={n} src={src} name={n} className="h-4 sm:h-6 max-w-[110px] sm:max-w-[150px] opacity-50 hover:opacity-90 transition-opacity duration-300 pointer-events-auto" />
        ))}
      </div>
    </div>
  );
}
